{ avatarDomain } = require '@trello/config'
naiveShouldComponentUpdate = require 'app/scripts/lib/util/naive-should-component-update'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('member')

module.exports = class MemberAvatar extends React.Component
  displayName: 'MemberAvatar'

  constructor: (props) ->
    super(props)

  shouldComponentUpdate: naiveShouldComponentUpdate

  render: t.renderable ->
    { avatarHash, email, username, fullName, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin, onClick, viewTitle } = @props

    t.div ->
      title = viewTitle
      if avatarHash
        avatarUrl = [avatarDomain, avatarHash, '30.png'].join('/')
        avatarUrl2x = [avatarDomain, avatarHash, '50.png'].join('/')
        t.img {
          class: 'member-avatar'
          height: '30'
          width: '30'
          src: avatarUrl
          srcSet: "#{avatarUrl} 1x, #{avatarUrl2x} 2x"
          alt: title
          title
        }
      else if initials?
        t.span '.member-initials', { title }, ->
          t.text initials
      else if email?
        t.span '.member-initials', { title }, ->
          t.text email[0].toUpperCase()

      if !isDeactivated
        if isBoardAdmin
          t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-board') }
        if isOrganizationAdmin
          t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization') }

      t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold') }
